export default {
  newPasswordTitle: {
    id: 'set_password_reset_new_password',
    defaultMessage: 'New password',
  },
  newPassword: {
    id: 'set_password_reset_input_password_first',
    defaultMessage: 'Password',
  },
  passwordConfirmTitle: {
    id: 'set_password_reset_confirmation_new_password',
    defaultMessage: 'Confirm the password',
  },
  passwordConfirm: {
    id: 'set_password_reset_input_password_second',
    defaultMessage: 'Password',
  },
  submit: {
    id: 'set_password_reset_button_submit',
    defaultMessage: 'Submit',
  },
  requiredFieldError: {
    id: 'form_rules_required',
    defaultMessage: 'This field is required',
  },
  passwordValidityError: {
    id: 'form_rules_password',
    defaultMessage: 'Insert a valid password',
  },
  passwordEqualityError: {
    id: 'set_password_reset_not_equal',
    defaultMessage: "These passwords don't match",
  },
  genericError: {
    id: 'set_password_generic_error',
    defaultMessage: 'Something went wrong. Please try again.',
  },
  invalidPassword: {
    id: 'input_password_wrong_format',
    defaultMessage: 'Insert a valid password',
  },
  passwordStrength: {
    id: 'input_password_password_too_weak_error',
    defaultMessage:
      'The password must have at least 8 characters, 1 uppercase letter, 1 lowercase letter and 1 digit.',
  },
  passwordTooSimilar: {
    id: 'input_password_password_too_similar_error',
    defaultMessage:
      "Your password can't be too similar to your other personal information.",
  },
  passwordTooCommon: {
    id: 'input_password_password_too_common_error',
    defaultMessage: "Your password can't be a commonly used password.",
  },
  passwordTooLong: {
    id: 'input_password_password_too_long_error',
    defaultMessage: 'Enter a password less than 64 characters.',
  },
  passwordReuse: {
    id: 'input_password_password_reuse_error',
    defaultMessage: 'This is an old password. Please create a new one.',
  },
  passwordButtonHideAriaLabel: {
    id: 'input_password_current_button_hide_label',
    defaultMessage: 'Hide password',
  },
  passwordButtonShowAriaLabel: {
    id: 'input_password_current_button_show_aria_label',
    defaultMessage: 'Reveal password',
  },
}
